document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lux-product').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var form = root.querySelector('.lux-form');
    var mainImg = root.querySelector('[id^="LuxMainImage-"]');
    var mainImageWrap = root.querySelector('[data-main-image-wrap]');
    var thumbsWrap = root.querySelector('[data-thumbs]');
    var thumbs = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('.lux-product__thumb'))
      : [];
    var variantInput = root.querySelector('[id^="LuxVariantId-"]');
    var picker = root.querySelector('.lux-variant-picker');
    var addBtn = root.querySelector('[id^="LuxAddToCart-"]');
    var buyBtn = root.querySelector('[id^="LuxBuyNow-"]');

    var productData = null;
    var productJsonEl = document.getElementById('LuxProductJson-' + sectionId);
    if (productJsonEl) {
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (err) {
        // If this fires, product.json failed to parse (usually a stray
        // </script> or unescaped character inside a metafield/description).
        // Color-swatch -> image matching silently stops working when this
        // happens, so surface it loudly instead of failing silent.
        console.error('[lux-product] Failed to parse product JSON — variant image matching will not work.', err);
        productData = null;
      }
    }

    var selectedOptions = {};
    if (picker) {
      // Seed initial state straight from the liquid-rendered
      // data-selected-value on each .lux-option wrapper (set from
      // option.selected_value server-side) rather than from whichever
      // button happens to carry ".is-active". This avoids relying on the
      // `value == option.selected_value` Liquid comparison, which can
      // fail to mark any swatch active when the option uses Shopify's
      // native color-swatch value objects.
      picker.querySelectorAll('.lux-option').forEach(function (optionEl) {
        var pos = optionEl.dataset.optionPosition;
        selectedOptions[pos] = optionEl.dataset.selectedValue;
      });
    }

    function findMatchingVariant() {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (pos) {
          return v['option' + pos] === selectedOptions[pos];
        });
      });
    }

    // Fallback for when the exact combination (e.g. this size + this color)
    // isn't a real sellable variant, but we still want the picture to switch
    // to whatever image IS assigned to that color/option value. Matches on
    // just the single option position that was just clicked, ignoring the
    // others, and prefers a match that actually has an image.
    function findVariantByOption(pos, value) {
      if (!productData || !productData.variants) return null;
      var candidates = productData.variants.filter(function (v) {
        return v['option' + pos] === value;
      });
      if (!candidates.length) return null;
      var withImage = candidates.find(function (v) { return v.featured_image; });
      return withImage || candidates[0];
    }

    function setActiveThumbByImageId(imageId) {
      if (!imageId) return;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.imageId) === String(imageId));
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.dataset.master = variant.featured_image.src;
        setActiveThumbByImageId(variant.featured_image.id);
      }

      [addBtn, buyBtn].forEach(function (btn) {
        if (!btn) return;
        if (variant.available) {
          btn.removeAttribute('disabled');
        } else {
          btn.setAttribute('disabled', 'disabled');
        }
      });

      var addText = root.querySelector('[data-add-to-cart-text]');
      if (addText) {
        addText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    // ---------- Swatch / variant selection ----------
    if (picker) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('.lux-swatch');
        if (!btn) return;

        var optionEl = btn.closest('.lux-option');
        var pos = optionEl.dataset.optionPosition;
        selectedOptions[pos] = btn.dataset.value;
        optionEl.dataset.selectedValue = btn.dataset.value;

        optionEl.querySelectorAll('.lux-swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        var selectedLabel = optionEl.querySelector('[data-selected-value]');
        if (selectedLabel) selectedLabel.textContent = btn.dataset.value;

        var variant = findMatchingVariant();

        if (variant) {
          updateForVariant(variant);
        } else {
          // Exact size+color combination isn't a real variant (or the
          // matched variant has no image of its own) — still swap the main
          // image to whatever picture IS assigned to the option that was
          // just clicked, so the swatch always shows the right photo even
          // if that exact combo can't be added to cart.
          console.warn('[lux-product] No exact variant matched selectedOptions — falling back to image-only match for the clicked option:', selectedOptions);

          var imageVariant = findVariantByOption(pos, btn.dataset.value);
          if (imageVariant && imageVariant.featured_image && mainImg) {
            mainImg.src = imageVariant.featured_image.src;
            mainImg.dataset.master = imageVariant.featured_image.src;
            setActiveThumbByImageId(imageVariant.featured_image.id);
          }

          if (variantInput) variantInput.value = '';
          [addBtn, buyBtn].forEach(function (b) {
            if (b) b.setAttribute('disabled', 'disabled');
          });
          var addText = root.querySelector('[data-add-to-cart-text]');
          if (addText) addText.textContent = 'Unavailable';
        }
      });
    }

    // ---------- Thumbnail click ----------
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.fullSrc;
          mainImg.dataset.master = thumb.dataset.fullSrcLarge || thumb.dataset.fullSrc;
        }
      });
    });

    // ---------- Swipe (change image) + Click-to-zoom-at-point ----------
    var isZoomed = false;
    var dragMoved = false;

    function setZoom(on, clientX, clientY) {
      if (!mainImg || !mainImageWrap) return;
      if (on) {
        var rect = mainImageWrap.getBoundingClientRect();
        var originX = ((clientX - rect.left) / rect.width) * 100;
        var originY = ((clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = originX + '% ' + originY + '%';
        mainImg.style.transform = 'scale(2.2)';
        mainImageWrap.classList.add('is-zoomed');
        isZoomed = true;
      } else {
        mainImg.style.transform = 'scale(1)';
        mainImageWrap.classList.remove('is-zoomed');
        isZoomed = false;
      }
    }

    if (mainImageWrap) {
      var startX = 0;
      var startY = 0;

      function goToDelta(diff) {
        if (thumbs.length < 2) return;
        if (Math.abs(diff) < 40) return;
        dragMoved = true;
        var activeIndex = thumbs.findIndex(function (t) {
          return t.classList.contains('is-active');
        });
        if (activeIndex === -1) activeIndex = 0;
        var nextIndex = diff < 0
          ? Math.min(activeIndex + 1, thumbs.length - 1)
          : Math.max(activeIndex - 1, 0);
        thumbs[nextIndex].click();
      }

      mainImageWrap.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragMoved = false;
      }, { passive: true });

      mainImageWrap.addEventListener('touchend', function (e) {
        var endX = e.changedTouches[0].clientX;
        goToDelta(endX - startX);
        if (!dragMoved) {
          setZoom(!isZoomed, endX, e.changedTouches[0].clientY);
        }
      });

      mainImageWrap.addEventListener('click', function (e) {
        if (dragMoved) {
          dragMoved = false;
          return;
        }
        // Skip on touch devices — touchend already handled the zoom toggle
        if (e.pointerType === 'touch') return;
        setZoom(!isZoomed, e.clientX, e.clientY);
      });
    }

    // ---------- Quantity ----------
    var qtyBox = root.querySelector('.lux-quantity__box');
    if (qtyBox) {
      var qtyInput = qtyBox.querySelector('input');
      var decreaseBtn = qtyBox.querySelector('[data-qty-decrease]');
      var increaseBtn = qtyBox.querySelector('[data-qty-increase]');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = val;
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var val = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.value = val;
        });
      }
    }

    // ---------- Size guide modal ----------
    var sizeGuideTrigger = root.querySelector('[data-size-guide-trigger]');
    var sizeGuideModal = document.getElementById('LuxSizeGuideModal-' + sectionId);
    if (sizeGuideTrigger && sizeGuideModal) {
      sizeGuideTrigger.addEventListener('click', function () {
        sizeGuideModal.hidden = false;
      });
      sizeGuideModal.querySelectorAll('[data-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          sizeGuideModal.hidden = true;
        });
      });
    }

    // Close size guide modal on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (sizeGuideModal) sizeGuideModal.hidden = true;
      if (isZoomed) setZoom(false);
    });

    // ---------- Add to cart / Buy now ----------
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitter = e.submitter;
        var isCheckout = !!(submitter && submitter.name === 'checkout');
        var formData = new FormData(form);

        var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (isCheckout) {
              window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.checkout_url) || '/checkout';
            } else {
              window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
            }
          })
          .catch(function () {
            form.submit();
          });
      });
    }
  });
});
